import React from 'react';

import { Icon, } from 'rsuite';

import NewChamado from '../../components/CadastroChamados/DrawerCadastro';

import styles from './styles.module.scss';

import useModal from '../../hooks/useModal';


function NewTicketFAB() {
  const newTicketModal = useModal();


  return (
    <div className={styles.buttonContainer} >
      <button
        onClick={newTicketModal.onOpen}
        className={styles.newTicketButton}
      >
        <Icon icon="plus" /> Novo chamado
      </button>

      <NewChamado
        show={newTicketModal.value}
        onClose={newTicketModal.onClose}
      />
    </div>
  )
}

export default NewTicketFAB;
